// extracted by mini-css-extract-plugin
module.exports = {"container":"_3nDdJppJaN-iOiSePJ8wr"};